<template>
  <el-container>
    <el-main>
      <el-row type="flex" justify="space-start" :gutter="30">
        <el-col :span="24">
          <el-card class="box-card">
            <div class="card-header">
              <h4 class="card-title">Frequently Bought Together</h4>
              <small>Orders containing 2 or more items</small>
            </div>

 <div class="table-responsive">
                <el-row style="margin-top:30px; margin-bottom: 10px">
                  <el-col :span="5">
                    <label class="control-label">Product Type</label>
                    <br />
                    <el-select @change="setTypes" v-model="productType" placeholder="select product">
                      <el-option v-for="product in productTypes" v-bind:key="product" :label="product" :value="product"></el-option>
                
                    </el-select>   <br /> <label class="control-label">Product:</label><br />
                  
                      <el-select @change="getOrders" v-model="searchProduct"  placeholder="select product">
                      <el-option v-for="product in setTypes(productType)" v-bind:key="product.id" :label="product.name" :value="product.id"></el-option>
                
                    </el-select>
                  </el-col>

                  <el-col :span="7">
                    <label class="control-label">Select Date Range</label>
                    <br />
                    <el-date-picker
                      @change="getOrders" 
                      v-model="filters[1].value"
                      type="daterange"
                      align="right"
                      unlink-panels
                      range-separator="-"
                      start-placeholder="Start date"
                      end-placeholder="End date"
                    
                    ></el-date-picker>
                        
                  </el-col>
                </el-row>
              </div>


              <div class="table-responsive">

    <el-alert v-if="error"
    title="Date range too high"
    type="error">
    Keep dates less than 12 months apart
  </el-alert>
              <!--<el-button @click="topKFrequent(data,21)">Get Top 20</el-button>-->
       

              <ol v-if="topProducts.length>0 && !error && !loading">
                  <h4 style="margin-left:-40px">Top {{top.length}} products</h4>
                  <li v-for="(product,i) in top"  v-bind:key="i">
                  
 {{topProducts.filter(o =>{return o.id==product[0]})[0].name}} - <b>{{product[1]}}</b>
                    
                  </li>
                  <h5 style="margin-left:-40px">Total Orders: {{orders.length}}</h5>
              </ol>
                <div v-else>No orders found</div>
     
     <button class="btn" v-if="orders.length>0" @click="showOrders=!showOrders"><span v-if="!showOrders">Show</span><span v-else>Hide</span> related orders</button>
                  <div v-if="orders.length>0 && !error && showOrders">
                    
                    <h4>Related Orders</h4>
                    <data-tables-server
                      class="table-shopping"
                      style="width: 100%"
                      :data="orders"
                      :tool-bar="true"
                      :current-page="1"
                      :total="orders.length"
                      :loading="loading"                    
                    :page-size="orders.length"
                   :pagination-props="{ pageSizes: [orders.length] }"
                     :default-sort = "{prop: 'product_no', order: 'descending'}" 
                    >
                     <el-table-column label="Order Id" min-width="25">
                        <template slot-scope="props">  <router-link :to="'/order/edit/'+props.row.id">{{props.row.id}}</router-link></template>
                      </el-table-column>
                      <el-table-column prop="dateCreated" label="Date" min-width="20">
                        <template
                          slot-scope="props"
                        >{{props.row.dateCreated | moment('YYYY-MM-DD')}}</template>
                      </el-table-column>

                      <el-table-column label="Products" min-width="160">
                        <template
                          slot-scope="props"
                        >{{props.row.product_name}} </template>
                      </el-table-column>

                      <el-table-column label="Product Ids" min-width="75">
                        <template slot-scope="props">{{props.row.product_ids}}</template>
                      </el-table-column>
                     <el-table-column sortable label="No. Products" min-width="75">
                        <template slot-scope="props">{{props.row.product_no}}</template>
                      </el-table-column>
                     

                    </data-tables-server>
                 
                  </div>
         
            
             
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
import moment from "moment";
import gql from "graphql-tag";
export default {
  data() {
    return {
      filters: [
        {
          value: "ALL",
          prop: "productPriceLabel",
        },
        {
          value: [moment().subtract(1, 'years').format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
          prop: "dateCreated",
        },
      ],
        showOrders:false,
      data: {},
      loading: false,
      orders: [],
      error: false,
      top: [],
      topProducts: [],
      products: [],
      productType: "",
      productTypes: ["online course", "combined course", "classroom course","extras","download","online extension"],
      onlineProduct: [],
      combinedProduct: [],
      classProduct: [],
      extraProduct:[],
      downloadProduct:[],
      extensionProduct:[],
      searchProduct: '',
      startDate: moment("2021-01-01"),
      endDate: moment("2021-05-11"),
    };
  },
  methods: {
    setTypes(type) {
      switch (type) {
        case "online course":
          return this.onlineProduct;
        case "combined course":
          return this.combinedProduct;
        case "classroom course":
          return this.classProduct;
        case "extras":
          return this.extraProduct;
        case "download":
          return this.downloadProduct;
        case "online extension":
          return this.extensionProduct;
      }
    },
  
    getOrders() {

      var monthsDiff = moment(this.filters[1].value[1]).diff(
        this.filters[1].value[0],
        "months",
        true
      );

      if (monthsDiff >= 13) {
        this.error = true;
        return;
      }
      this.loading = true;
      this.error = false;
      let query = gql`
        query frequently(
          $product: jsonb!
          $fromDate: timestamp!
          $toDate: timestamp!
        ) {
          orders: orders_with_many_products(
            where: {
              product_ids: { _contains: $product }
              dateCreated: { _gte: $fromDate, _lte: $toDate }
            }
          ) {
            product_name
            dateCreated
            id
            product_ids
            product_no
          }
        }
      `;
      this.$apollo
        .query({
          // desc_nulls_last filters out any null data
          query: query,
          variables: {
            product: parseInt(this.searchProduct),
            fromDate: this.filters[1].value[0],
            toDate: this.filters[1].value[1],
          },
          // can get error if needed
          error(error) {
            this.error = JSON.stringify(error);
          },
        })
        .then((response) => {
       
          this.orders = response.data.orders;
          this.topKFrequent(this.orders, 21,this.searchProduct);
        });
    },
    getProducts() {
      let query = gql`
        query MyQuery {
          Product(
            where: { id: { _nin: [143, 149, 146, 147] } }
            order_by: { type: asc }
          ) {
            name
            id
            type
          }
        }
      `;
      this.$apollo
        .query({
          // desc_nulls_last filters out any null data
          query: query,
          // can get error if needed
          error(error) {
            this.error = JSON.stringify(error);
          },
        })
        .then((response) => {
          this.products = response.data.Product;
          this.onlineProduct = this.products.filter((p) => {
            return p.type == "online course";
          });
          this.combinedProduct = this.products.filter((p) => {
            return p.type == "combined course";
          });
          this.classProduct = this.products.filter((p) => {
            return p.type == "classroom course";
          });
          this.extraProduct = this.products.filter((p) => {
            return p.type == "extras";
          });
          this.downloadProduct = this.products.filter((p) => {
            return p.type == "download";
          });
          this.extensionProduct = this.products.filter((p) => {
            return p.type == "online extension";
          });
        });
    },

    topKFrequent(nums, k,product) {
      //console.log(nums);
      let d = nums.map((order) => {
        return order.product_ids;
      });
      d = [].concat.apply([], d);
      //console.log(d);

      let hash = {};

      for (let num of d) {
        if (!hash[num]) hash[num] = 0;
        hash[num]++;
      }
     // console.log("hash", hash);
      const hashToArray = Object.entries(hash);
      const sortedArray = hashToArray.sort((a, b) => b[1] - a[1]);
     // console.log("hash", sortedArray);
      this.top = sortedArray
        .map((num) => [parseInt(num[0]), parseInt(num[1])]).filter(function(el) { return el[0] !==product; })
        //.slice(1, k)
        .slice(0, k);
      const sortedElements = sortedArray.map((num) => parseInt(num[0]));
      const toFind = sortedElements;
      //console.log(this.top);
      this.getProductNames(toFind);
    },
    getProductNames(arr) {
      let query = gql`query MyQuery {
  Product(where: {id: {_in: [${arr}]}}) {
    name
    id
  }
}
`;

      this.$apollo
        .query({
          // desc_nulls_last filters out any null data
          query: query,
          // can get error if needed
          error(error) {
            this.error = JSON.stringify(error);
          },
        })
        .then((response) => {
               this.loading = false;
          this.topProducts = response.data.Product;
        });
    },
  },
  mounted() {
    this.getProducts();
    //this.searchProduct={value:25,label:'hello'};
    // this.getOrders();
  },
};
</script>

<style  scoped>
.pagination-bar{display:none}
</style>


// WEBPACK FOOTER //
// src/components/Reports/frequentlyBought.vue